import { AppNS } from 'app';
import { apiGetCompanyById } from 'app/api_v2/companies';
import { apiGetInspectorDisciplines } from 'app/api_v2/inspectors/disciplines';
import { apiGetProfile } from 'app/api_v2/inspectors/profile';
import { apiGetMerchantAccount } from 'app/api_v2/merchant-accounts/merchant-accounts';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const useGetCompanyQuery = (
  id: string,
  queryOptions: UseQueryOptions<AppNS.Company, string[], AppNS.Company> = {}
) => {
  return useQuery({
    queryKey: ['companies', id],
    queryFn: () => apiGetCompanyById(id),
    enabled: id !== '',
    ...queryOptions,
  });
};

export const useGetInspectorQuery = (
  id: string,
  queryOptions: UseQueryOptions<AppNS.InspectorProfile, string[], AppNS.InspectorProfile> = {}
) => {
  return useQuery({
    queryKey: ['inspectors', id],
    queryFn: ({ signal }) => apiGetProfile(id, signal),
    enabled: id !== '',
    ...queryOptions,
  });
};

export const useGetInspectorDisciplinesQuery = (
  id: string,
  queryOptions: UseQueryOptions<AppNS.InspectorDiscipline[], string[], AppNS.InspectorDiscipline[]> = {},
  params: AppNS.Params = {}
) => {
  return useQuery({
    queryKey: ['inspectorDisciplines', id],
    queryFn: () => apiGetInspectorDisciplines({ user_id: id, ...params }),
    enabled: id !== '',
    ...queryOptions,
  });
};

export const useGetMerchantAccount = (
  id: string,
  queryOptions: UseQueryOptions<AppNS.MerchantAccount, string[], AppNS.MerchantAccount> = {}
) => {
  return useQuery({
    queryKey: ['merchantAccounts', id],
    queryFn: () => apiGetMerchantAccount(id),
    enabled: !!id,
    ...queryOptions,
  });
};
